export const isLogin = (token,id)=>{
    return token&&(id!==0)
}